import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    MDBBtn,
    MDBIcon,
    MDBTable,
    MDBTableBody,
    MDBTableHead,
    MDBTooltip,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBInput,
    MDBDropdown,
    MDBDropdownToggle,
    MDBDropdownMenu,
    MDBDropdownItem,
    MDBFile
} from "mdb-react-ui-kit";

export default function ParticipantTable() {
    const [events, setEvents] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState("");
    const [participants, setParticipants] = useState([]);
    const [modal, setModal] = useState(false);
    const [modalType, setModalType] = useState("");
    const [currentParticipant, setCurrentParticipant] = useState({
        privateCode: "",
        name: "",
        affiliation: "",
        gender: "",
        contactNumber: "",
        email: "",
        attend_time: ""
    });
    const [file, setFile] = useState(null);
    const [csvModal, setCsvModal] = useState(false);  // CSV Modal 상태 추가

    // 페이지네이션 관련 상태
    const [currentPage, setCurrentPage] = useState(0);
    const pageSize = 100; // 한 페이지에 표시할 항목 수

    const fetchEvents = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/qr-events/list`);
            setEvents(response.data);
        } catch (error) {
            console.error("행사를 가져오는 중 오류가 발생했습니다.", error);
        }
    };

    const fetchParticipants = async (eventName, page = 0) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/qr-event-participant/paginated-list`, {
                event_name: eventName,
                page: page,
                size: pageSize
            });
            setParticipants(response.data); // 현재 페이지의 참가자 목록
            setSelectedEvent(eventName);
            setCurrentPage(page);
        } catch (error) {
            console.error("참가자를 가져오는 중 오류가 발생했습니다.", error);
        }
    };

    useEffect(() => {
        fetchEvents();
    }, []);

    const toggleModal = (type = "", participant = {}) => {
        // 행사를 선택하지 않았을 때 경고
        if (!selectedEvent && type === "add") {
            alert("참가자를 추가하려면 먼저 행사를 선택해주세요.");
            return;
        }
        setModal(!modal);
        setModalType(type);
        setCurrentParticipant(participant);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setCurrentParticipant((prev) => ({ ...prev, [name]: value }));
    };

    const handlePhoneNumberChange = (e) => {
        let value = e.target.value.replace(/[^0-9]/g, ''); // 숫자만 남기기

        // 포맷팅: 010-1234-5678 형식
        if (value.length > 3 && value.length <= 7) {
            value = `${value.slice(0, 3)}-${value.slice(3)}`;
        } else if (value.length > 7) {
            value = `${value.slice(0, 3)}-${value.slice(3, 7)}-${value.slice(7, 11)}`;
        }

        setCurrentParticipant((prev) => ({ ...prev, contactNumber: value }));
    };

    const handleSave = async () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(currentParticipant.email)) {
            alert("올바른 이메일 형식을 입력해주세요.");
            return;
        }

        const phoneRegex = /^010-\d{4}-\d{4}$/;
        if (!phoneRegex.test(currentParticipant.contactNumber)) {
            alert("전화번호는 010-0000-0000 형식으로 입력해주세요.");
            return;
        }

        if (!currentParticipant.name || !currentParticipant.affiliation || !currentParticipant.gender || !currentParticipant.contactNumber || !currentParticipant.email) {
            alert("모든 필드를 채워주세요.");
            return;
        }

        try {
            if (modalType === "add") {
                // `eventName`과 `currentParticipant`를 함께 객체로 전달
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/qr-event-participant/register`, {
                    eventName: selectedEvent,
                    participant: currentParticipant
                });
            } else if (modalType === "edit") {
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/qr-event-participant/update`, {
                    eventName: selectedEvent,
                    participant: currentParticipant
                });
            }
            await fetchParticipants(selectedEvent, currentPage);
            toggleModal();
        } catch (error) {
            console.error("존재하지 않는 행사거나 중복되는 참가자(이메일과 행사로 구분) 입니다", error);
            alert("에러 발생 : " + error)
        }
    };

    const handleDelete = async () => {
        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/qr-event-participant/delete`, {
                private_code: currentParticipant.privateCode
            });
            await fetchParticipants(selectedEvent, currentPage);
            toggleModal();
        } catch (error) {
            console.error("참가자 삭제 중 오류가 발생했습니다.", error);
        }
    };

    const toggleCsvModal = () => {
        if (!selectedEvent) {
            alert("xlsx 파일을 업로드하려면 먼저 행사를 선택해주세요.");
            return;
        }
        setCsvModal(!csvModal);
    };

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleUploadCSV = async () => {
        if (!file) {
            alert("xlsx 파일을 선택해주세요.");
            return;
        }
        const formData = new FormData();
        formData.append("file", file);
        formData.append("eventName", selectedEvent);

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/qr-event-participant/upload`, formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            alert(response.data);
            await fetchParticipants(selectedEvent, currentPage);  // 파일 업로드 후 참가자 목록 새로고침
            toggleCsvModal();  // 모달 닫기
        } catch (error) {
            console.error("xlsx 파일 업로드 중 오류가 발생했습니다.", error);
            alert("xlsx 파일 업로드 중 오류가 발생했습니다.");
        }
    };

    // 날짜와 시간 포맷팅 함수 추가
    const formatDateTime = (datetime) => {
        if (!datetime) return "";
        const date = new Date(datetime);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    // 페이지네이션 화살표 버튼
    const handlePreviousPage = () => {
        if (currentPage > 0) {

            fetchParticipants(selectedEvent, currentPage-1);
        }
    };

    const handleNextPage = () => {
        fetchParticipants(selectedEvent, currentPage+1);
    };

    return (
        <div className="center-text" style={{ position: "relative" }}>
            <MDBDropdown>
                <MDBDropdownToggle color="primary">행사 선택</MDBDropdownToggle>
                <MDBDropdownMenu>
                    {events.map((event) => (
                        <MDBDropdownItem link key={event.eventName} onClick={() => fetchParticipants(event.eventName)}>
                            {event.eventName}
                        </MDBDropdownItem>
                    ))}
                </MDBDropdownMenu>
            </MDBDropdown>
            <h5 className="mt-3">선택된 행사: {selectedEvent}</h5>

            <MDBTable responsive="lg" hover className="mt-3">
                <MDBTableHead>
                    <tr>
                        <th scope="col">개인코드
                            <MDBTooltip tag="a" wrapperProps={{ href: "#" }} title="QR 코드와 동일한 값이에요">
                                <MDBIcon far icon="question-circle" />
                            </MDBTooltip>
                        </th>
                        <th scope="col">이름</th>
                        <th scope="col">소속</th>
                        <th scope="col">성별</th>
                        <th scope="col">연락처</th>
                        <th scope="col">시트명</th>
                        <th scope="col">이메일</th>
                        <th scope="col">참석 시간
                            <MDBTooltip tag="a" wrapperProps={{ href: "#" }} title="최초 참석 시간을 의미해요">
                                <MDBIcon far icon="question-circle" />
                            </MDBTooltip>
                        </th>
                        <th scope="col">관리</th>

                    </tr>
                </MDBTableHead>
                <MDBTableBody style={{ textAlign: "center", verticalAlign: "middle" }}>
                    {participants && participants.map((participant, index) => (
                        <tr key={index}>
                            <td>{participant.privateCode}</td>
                            <td>{participant.name}</td>
                            <td>{participant.affiliation}</td>
                            <td>{participant.gender}</td>
                            <td>{participant.contactNumber}</td>
                            <td>{participant.sheetName}</td>
                            <td>{participant.email}</td>
                            <td>{formatDateTime(participant.attendTime)}</td>
                            <td>
                                <MDBBtn color="info" size="sm" onClick={() => toggleModal("edit", participant)}>
                                    수정
                                </MDBBtn>{" "}
                                <MDBBtn color="danger" size="sm" onClick={() => toggleModal("delete", participant)}>
                                    삭제
                                </MDBBtn>
                            </td>
                        </tr>
                    ))}
                </MDBTableBody>
            </MDBTable>

            {/* 페이지네이션 화살표 */}
            <div className="pagination-controls" style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                <MDBBtn color="primary" onClick={handlePreviousPage} disabled={currentPage === 0}>
                    이전
                </MDBBtn>
                <span style={{ margin: "0 15px", lineHeight: "35px" }}>{currentPage + 1}</span>
                <MDBBtn color="primary" onClick={handleNextPage}>
                    다음
                </MDBBtn>
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end", padding: "10px" }}>
                <MDBBtn
                    color="warning"
                    onClick={toggleCsvModal}
                    disabled={!selectedEvent}
                    style={{ marginRight: "10px" }} // 버튼 간의 간격 추가
                >
                    참가자 xlsx로 추가하기
                </MDBBtn>

                <MDBBtn
                    color="success"
                    onClick={() => toggleModal("add")}
                    disabled={!selectedEvent}
                >
                    참가자 추가
                </MDBBtn>
            </div>

            {/* CSV Modal */}
            <MDBModal open={csvModal} onClose={() => setCsvModal(false)} tabIndex="-1" centered>
                <MDBModalDialog centered>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>xlsx 파일 업로드</MDBModalTitle>
                            <MDBBtn className="btn-close" color="none" onClick={toggleCsvModal}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <MDBFile type="file" accept=".xlsx" onChange={handleFileChange} />
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleCsvModal}>
                                취소
                            </MDBBtn>
                            <MDBBtn color="primary" onClick={handleUploadCSV}>
                                업로드
                            </MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>

            <MDBModal open={modal} onClose={() => setModal(false)} tabIndex="-1" centered>
                <MDBModalDialog centered>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>
                                {modalType === "add" ? "참가자 추가" : modalType === "edit" ? "참가자 수정" : "참가자 삭제"}
                            </MDBModalTitle>
                            <MDBBtn className="btn-close" color="none" onClick={() => toggleModal()}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            {modalType === "delete" ? (
                                <p>정말로 '{currentParticipant.name}' 참가자를 삭제하시겠습니까?</p>
                            ) : (
                                <>
                                    <MDBInput
                                        label="이름"
                                        name="name"
                                        value={currentParticipant.name}
                                        onChange={handleInputChange}
                                        className="mb-3"
                                    />
                                    <MDBInput
                                        label="소속"
                                        name="affiliation"
                                        value={currentParticipant.affiliation}
                                        onChange={handleInputChange}
                                        className="mb-3"
                                    />
                                    <MDBInput
                                        label="성별 (Male/Female/Other)"
                                        name="gender"
                                        value={currentParticipant.gender}
                                        onChange={handleInputChange}
                                        className="mb-3"
                                    />
                                    <MDBInput
                                        label="연락처 (010-0000-0000 형식)"
                                        name="contactNumber"
                                        value={currentParticipant.contactNumber}
                                        onChange={handlePhoneNumberChange}
                                        className="mb-3"
                                    />
                                    <MDBInput
                                        label="이메일"
                                        name="email"
                                        value={currentParticipant.email}
                                        onChange={handleInputChange}
                                        className="mb-3"
                                    />
                                </>
                            )}
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={() => toggleModal()}>
                                취소
                            </MDBBtn>
                            {modalType === "delete" ? (
                                <MDBBtn color="danger" onClick={handleDelete}>
                                    삭제
                                </MDBBtn>
                            ) : (
                                <MDBBtn color="primary" onClick={handleSave}>
                                    저장
                                </MDBBtn>
                            )}
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </div>
    );
}